import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import Links from "../../../Links";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import Capture1 from "../../../../img/capturex-1.jpg";
import Capture2 from "../../../../img/capturex-2.jpg";

const CaptureProjectSection = styled(ProjectSection)`
  background: #703993;
`;

const Button = styled(Links)`
  display: inline-block;
  text-align: center;
  color: white;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border-bottom: none;
  background-color: rgba(0, 0, 0, 0.05);
  font-size: var(--font-size-text-small);
  &:hover,
  &:active {
    background-color: rgba(0, 0, 0, 0.3);
    color: #ffeb3b;
  }
  &:visited {
    color: white;
  }
  &:focus {
    outline-color: white;
  }
`;

const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: auto;
  justify-content: center;
  gap: var(--spacing-small);
  margin-bottom: var(--spacing-large);
`;

function Capture() {
  return (
    <CaptureProjectSection>
      <ProjectTitle title="Capture" tag="2017" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
      </ProjectSectionSkills>
      <ProjectDescription>
        The capture experience allows business owners to record and store their business-related expenses in a
        convenient and accessible digital format. By having this document available in the MYOB, the system enables
        their accountant to have access to all the information they need for the tax period.
      </ProjectDescription>
      <ButtonGroup>
        <Button href="/case-studies#expenses">Case Study</Button>
      </ButtonGroup>
      <ProjectHeroImage srcMobile1={Capture1} srcMobile2={Capture2} mobile lazy />
    </CaptureProjectSection>
  );
}

export default Capture;
